import axios from 'axios';
import store from '../store';
import { setUserLogout } from '../store/reducers/account_reducer';
import { getStoredData, get_master_auth_key, get_auth_key } from '../util';

axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;

const masterPaths = ['/v1/users/me'];

axios.interceptors.request.use(
  function (config) {
    const isMasterRequest = masterPaths.includes(config.url);
    const storedData = isMasterRequest ? JSON.parse(getStoredData(get_master_auth_key())) : JSON.parse(getStoredData(get_auth_key()));
    if (storedData) {
      config.headers['x-access-token'] = isMasterRequest ? storedData.masterToken : storedData.token;
    }
    return config;
  },
  function (error) {
    if (error instanceof Error) {
      return Promise.reject(error);
    }
    return Promise.reject(new Error(String(error)));
  }
);

axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    const isLoginPage = window.location.hash === '#/' || window.location.hash === '';
    if (error.response && error.response.status === 401 && !isLoginPage) {
      store.dispatch(setUserLogout());
      window.location = process.env.REACT_APP_FRONTEND_URL;
    } else if (error instanceof Error) {
      return Promise.reject(error);
    }
    return Promise.reject(new Error(String(error)));
  }
);

export default axios;
